import { Component, OnInit } from '@angular/core';
import {
  ApplicationState,
  getNortonAccount,
  getNortonAccountPending,
  getNortonAccountTechnicalError,
  getProducts,
} from '../../store/reducers';
import { OnDestroyHookDirective } from '../../shared/hooks';
import { Store } from '@ngrx/store';
import { TranslationService } from '@proximus/ng-common';
import { Product } from '@dch/products-business-logic';
import { GetNortonAccount } from '../store/actions/norton.actions';
import { Alert, AlertsService } from '@proximus/ng-common-components';

@Component({
  selector: 'mprd-norton-activation',
  templateUrl: './norton-activation.component.html',
  styleUrls: ['./norton-activation.component.css'],
})
export class NortonActivationComponent
  extends OnDestroyHookDirective
  implements OnInit
{
  productKey: string;
  nortonAccount: string;
  dataLoaded = false;
  isPending = false;

  constructor(
    private store: Store<ApplicationState>,
    private translationService: TranslationService,
    private alertService: AlertsService,
  ) {
    super();
  }

  ngOnInit() {
    this.addSubscription(
      this.store.select(getNortonAccount).subscribe((value) => {
        if (value && value.nortonAccount) {
          this.productKey = value.nortonAccount.pin;
          this.nortonAccount = value.nortonAccount.login;
        }
      }),
    );
    this.addSubscription(
      this.store.select(getNortonAccountPending).subscribe((value) => {
        this.isPending = value;
      }),
    );
    this.addSubscription(
      this.store.select(getNortonAccountTechnicalError).subscribe((error) => {
        if (error) {
          const alert: Alert = {
            isClosable: false,
            alertKey: 'nortonActivationAlert',
            title: this.translationService.getTranslatedValueFor(
              'norton.activation.error.title',
            ),
            description: this.translationService.getTranslatedValueFor(
              'norton.activation.error.description',
            ),
            type: 'error',
          };
          this.alertService.dispatchAlert(alert);
        }
      }),
    );
    this.addSubscription(
      this.store.select(getProducts).subscribe((products) => {
        if (products && products.length > 0 && !this.dataLoaded) {
          this.dataLoaded = true;
          const ssids = this.getSsids(products);
          if (ssids.length > 0) {
            const payload = {
              ssids,
            };
            this.store.dispatch(new GetNortonAccount(payload));
          }
        }
      }),
    );
  }

  private getSsids(products: Array<Product>) {
    const norton1MpcUuid = this.translationService.getTranslatedValueFor(
      'norton.subscription.norton1MpcUuid',
    );
    const norton5MpcUuid = this.translationService.getTranslatedValueFor(
      'norton.subscription.norton5MpcUuid',
    );
    return products
      .filter((product) =>
        [norton1MpcUuid, norton5MpcUuid].includes(product.groupMpcUuid),
      )
      .map((product) => product.accessNumber);
  }
}
